module.exports = __webpack_public_path__ + "static/img/c1-disappointed.80be5d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatars/c1-disappointed.gif
// module id = 27
// module chunks = 0